import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import { withTranslation, withNamespaces } from "react-i18next";

// styles
import style from '../../Styles/Containers/Photo.module.css'

//component
import CarmeraFooter from '../../Components/Footer/cameraFooter.jsx'

class PhotoContainer extends Component {

    constructor() {
        super();
        this.state = {
            scanName: "QR",
            flashOn: true,
            isLoading: true,
            bottomContent: null
        }
    }

    componentDidMount() {
        const footer = this.footer;

        const messageCard = <div className={style.bottomMessageCard}>
            <span className={style.bottomMessageFont}>{this.props.t('touch_object')}</span>
        </div>;

        this.setState({
            bottomContent: messageCard
        })
    }

    get scanView() {
        switch (this.state.scanName) {
            case 'QR':
                return this.props.t('scan_qr_code');
                break;

            case 'NFC':
                return "QR를 태깅해주세요"
                break;

            case 'AR':
                return "QR코드를 비춰주세요"
                break;
        }
    }

    get loadingProgress() {
        return <div className={style.loadingProgress}>
            <div className={style.loadingDot}></div>
            <div className={style.loadingDot} style={{animationDelay: "0.3s"}}/>
            <div className={style.loadingDot} style={{animationDelay: "0.6s"}}></div>
            <span className={style.loadingFont}>인식중 입니다</span>
        </div>
    }

    get footer() {
        return <React.Fragment>
            <div className={style.circleButtonArea}>
                <div onClick={() => this.onScanIconClick("QR")}>
                    {this.state.scanName !== 'QR' ?
                        <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-qr.svg"} className={style.circleButton}></img>
                        : <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-qr-on.svg"} className={style.circleButton}></img>}

                </div>
                <div onClick={() => this.onScanIconClick("NFC")}>
                    {this.state.scanName !== 'NFC' ?
                        <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-nfc.svg"} className={style.circleButton}></img>
                        : <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-nfc-on.svg"} className={style.circleButton}></img>}
                </div>
                <div onClick={() => this.onScanIconClick("AR")}>
                    {this.state.scanName !== 'AR' ?
                        <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-ar.svg"} className={style.circleButton}></img>
                        : <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/btn-ar-on.svg"} className={style.circleButton}></img>}
                </div>
            </div>
            <div className={style.footer}>
                <CarmeraFooter/>
            </div>
        </React.Fragment>
    }

    render() {
        const { t } = this.props;

        return (
            <div className={style.container} style={{height: window.innerHeight}}>
                <div className={style.topIconArea}>
          <span className={style.icon} onClick={() => {
              this.setState({
                  flashOn: !this.state.flashOn
              })
          }}>
              {this.state.flashOn ? <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-flash-on.svg"} className={style.icon}></img>
                  : <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-flash-off.svg"} className={style.icon}></img>}
          </span>
                    {this.state.scanName !== 'NFC' &&
                    <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-help.svg"} className={[style.icon]} style={{float: "right"}}></img>}
                </div>
                <div className={style.font}>
                    {this.scanView}
                </div>

                {this.state.isLoading ? this.loadingProgress
                    :
                    this.state.scanName !== 'NFC' ?
                        <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/scan.svg"} className={style.squareScan}></img>
                        : <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-nfc-tag.svg"} className={style.nfcScan}></img>}
                {this.state.bottomContent}
            </div>

        )
    }

    onScanIconClick(scanName) {
        this.setState({
            scanName: scanName
        })
    }

    toggleFlashIcon() {
        this.setState({
            flashOn: !this.state.flashOn
        })
    }
}

export default connect()(withRouter(withTranslation()(PhotoContainer)));
